import main from "@/views/main";

// login
const login = {
  path: "/login",
  name: "Login",
  meta: {
    title: "登录"
  },
  component: resolve => {
    require(["@/views/login/login.vue"], resolve);
  }
};

// 500
const page500 = {
  path: "/500",
  name: "error-500",
  meta: {
    title: "500 - 请求错误"
  },
  component: resolve => {
    require(["@/views/common/500.vue"], resolve);
  }
};

// 403
const page403 = {
  path: "/403",
  name: "error-403",
  meta: {
    title: "403 - 无权限"
  },
  component: resolve => {
    require(["@/views/common/403.vue"], resolve);
  }
};

// 404
const page404 = {
  path: "/*",
  name: "error-404",
  meta: {
    title: "404 - 页面不存在"
  },
  component: resolve => {
    require(["@/views/common/404.vue"], resolve);
  }
};

const other = [
  {
    path: "/",
    component: main,
    meta: {
      title: "首页",
      icon: "uc-menu-icon-index"
    },
    children: [
      {
        path: "/customer/details",
        name: "customer-details",
        meta: {
          title: "交易信息",
          pathWay: "2-1-1"
        },
        component: resolve => {
          require(["@/views/multiagent/details.vue"], resolve);
        }
      }
    ]
  }
];

export const routers = [
  {
    path: "/",
    component: main,
    meta: {
      title: "首页",
      icon: "uc-menu-icon-index",
      pathWay: "1"
    },
    redirect: "/home",
    children: [
      {
        path: "/home",
        name: "home",
        meta: { title: "首页", pathWay: "1-1" },
        component: resolve => {
          require(["@/views/home/home.vue"], resolve);
        }
      }
    ]
  },
  {
    path: "/",
    meta: {
      title: "机构客户专区",
      icon: "uc-menu-icon-jgkh",
      pathWay: "2"
    },
    component: main,
    children: [
      {
        path: "/customer",
        name: "customer",
        meta: { title: "名下用户", pathWay: "2-1" },
        component: resolve => {
          require(["@/views/multiagent/customerIndex.vue"], resolve);
        }
      },
      {
        path: "/commManage",
        name: "commManage",
        meta: { title: "佣金管理", pathWay: "2-2" },
        component: resolve => {
          require(["@/views/multiagent/commManage.vue"], resolve);
        }
      },
      {
        path: "/reportView",
        name: "reportView",
        meta: { title: "报表预览", pathWay: "2-3" },
        component: resolve => {
          require(["@/views/multiagent/reportView.vue"], resolve);
        }
      },
      {
        path: "/extensionlink",
        name: "extensionlink",
        meta: { title: "推广链接", pathWay: "2-4" },
        component: resolve => {
          require(["@/views/multiagent/extensionlink.vue"], resolve);
        }
      }
    ]
  },
  {
    path: "/",
    meta: {
      title: "账户资料",
      icon: "uc-menu-icon-zhzl",
      pathWay: "3"
    },
    component: main,
    children: [
      {
        path: "/account/upgrade",
        name: "upgrade",
        meta: { title: "账户升级", pathWay: "3-1", auth: "0" },
        component: resolve => {
          require(["@/views/integration/upgrade.vue"], resolve);
        }
      },
      {
        path: "/integration",
        name: "integration",
        meta: { title: "我的积分", pathWay: "3-2", auth: "0" },
        component: resolve => {
          require(["@/views/integration/index.vue"], resolve);
        }
      },
      {
        path: "/integration/detail",
        name: "integration_detail",
        meta: { title: "我的积分", hide: true },
        component: resolve => {
          require(["@/views/integration/detail.vue"], resolve);
        }
      },
      {
        path: "/basicMsg",
        name: "basicMsg",
        meta: { title: "实名认证", pathWay: "3-3", auth: "0" },
        component: resolve => {
          require(["@/views/accountinfo/basicMsg.vue"], resolve);
        }
      },
      {
        path: "/bankMsg",
        name: "bankMsg",
        meta: { title: "银行卡资料", pathWay: "3-4" },
        component: resolve => {
          require(["@/views/accountinfo/bankMsg.vue"], resolve);
        }
      },
      {
        path: "/password",
        name: "password",
        meta: { title: "修改密码", pathWay: "3-5", auth: "0" },
        component: resolve => {
          require(["@/views/accountinfo/password.vue"], resolve);
        }
      }
    ]
  },
  {
    path: "/",
    meta: {
      title: "资金管理",
      icon: "uc-menu-icon-zjgl",
      pathWay: "4"
    },
    component: main,
    children: [
      // { path: '/antbag', name: 'antbag', meta: { title: '快捷支付', pathWay: '4-1', type: 'deposit' }, component: resolve => { require(['@/views/fund/antbag.vue'], resolve) } },
      // { path: '/deposit', name: 'deposit', meta: { title: '网上支付', pathWay: '4-2', auth: '0', type: 'deposit' }, component: resolve => { require(['@/views/fund/deposit.vue'], resolve) } },
      // { path: '/transferPayment', name: 'transferPayment', meta: { title: '转账支付', pathWay: '4-3', type: 'deposit' }, component: resolve => { require(['@/views/fund/transferPayment.vue'], resolve) } },
      // { path: '/bankremittance', name: 'bankremittance', meta: { title: '银行汇款', pathWay: '4-4', type: 'deposit' }, component: resolve => { require(['@/views/fund/bankremittance.vue'], resolve) } },
      // { path: '/recharge', name: 'recharge', meta: { title: '商城支付', pathWay: '4-5' }, component: resolve => { require(['@/views/fund/recharge.vue'], resolve) } },
      // { path: '/lightningPayment', name: 'lightningPayment', meta: { title: '网上充值', pathWay: '4-6' }, component: resolve => { require(['@/views/fund/lightningPayment.vue'], resolve) } },
      {
        path: "/deposit",
        name: "deposit",
        meta: { title: "存款" },
        component: resolve => {
          require(["@/views/fund/cashRegister.vue"], resolve);
        }
      },
      {
        path: "/withdraw",
        name: "withdraw",
        meta: { title: "提现", pathWay: "4-7" },
        component: resolve => {
          require(["@/views/fund/withdraw.vue"], resolve);
        }
      },
      {
        path: "/digitalCurrency",
        name: "DigitalCurrency",
        meta: { title: "币地址管理", pathWay: "4-7-1" },
        component: resolve => {
          require(["@/views/fund/DigitalCurrency.vue"], resolve);
        }
      },
      {
        path: "/fundDetail",
        name: "fundDetail",
        meta: { title: "资金明细", pathWay: "4-8" },
        component: resolve => {
          require(["@/views/fund/fundDetail.vue"], resolve);
        }
      },
      {
        path: "/dollarGift",
        name: "dollarGift",
        meta: { title: "美元赠金点" },
        component: resolve => {
          require(["@/views/dollarGift/index.vue"], resolve);
        }
      }
    ]
  },
  {
    path: "/",
    meta: {
      title: "交易信息",
      icon: "uc-menu-icon-jyxx",
      pathWay: "5"
    },
    component: main,
    children: [
      {
        path: "/position",
        name: "position",
        meta: { title: "持仓", pathWay: "5-1" },
        component: resolve => {
          require(["@/views/tradeinfo/position.vue"], resolve);
        }
      },
      {
        path: "/closePosition",
        name: "closePosition",
        meta: { title: "平仓", pathWay: "5-2" },
        component: resolve => {
          require(["@/views/tradeinfo/closePosition.vue"], resolve);
        }
      }
    ]
  },
  {
    path: "/",
    meta: {
      title: "服务中心",
      icon: "uc-menu-icon-fwzx",
      pathWay: "6"
    },
    component: main,
    children: [
      {
        path: "/softDownload",
        name: "softDownload",
        meta: { title: "软件下载", pathWay: "6-1" },
        component: resolve => {
          require(["@/views/service/softDownload.vue"], resolve);
        }
      },
      //{ path: '/crudeTrading', name: 'crudeTrading', meta: { title: '原油交易细则', pathWay: '6-2' }, component: resolve => { require(['@/views/service/crudeTrading.vue'], resolve) } },
      {
        path: "/suggestion",
        name: "suggestion",
        meta: { title: "投诉建议", pathWay: "6-3" },
        component: resolve => {
          require(["@/views/service/suggestion.vue"], resolve);
        }
      },
      {
        path: "/myMsg",
        name: "myMsg",
        meta: { title: "我的消息", pathWay: "6-4" },
        component: resolve => {
          require(["@/views/service/myMsg.vue"], resolve);
        }
      },
      {
        path: "/contact",
        name: "contact",
        meta: { title: "联系我们", pathWay: "6-5" },
        component: resolve => {
          require(["@/views/service/contact.vue"], resolve);
        }
      }
    ]
  },
  // {
  //   path: '/',
  //   component: main,
  //   meta: {
  //     title: '账户升级',
  //     icon: 'el-icon-upload2',
  //     pathWay: '7'
  //   },
  //   children: [
  //     { path: '/upGrade', name: 'upGrade', meta: { title: '账户升级', pathWay: '7-1' }, component: resolve => { require(['@/views/upgrade/upgrade.vue'], resolve) } },
  //   ]
  // },
  {
    path: "/",
    component: main,
    meta: {
      title: "邀请好友",
      icon: "uc-menu-icon-ldx",
      pathWay: "7"
    },
    children: [
      {
        path: "/InvitingFriends",
        name: "InvitingFriends",
        meta: { title: "活动主页", pathWay: "7-1" },
        component: resolve => {
          require(["@/views/InvitingFriends/InvitingFriends.vue"], resolve);
        }
      },
      {
        path: "/BonusDetails",
        name: "BonusDetails",
        meta: { title: "奖励明细", pathWay: "7-2" },
        component: resolve => {
          require(["@/views/InvitingFriends/BonusDetails.vue"], resolve);
        }
      },
      {
        path: "/SettlementRecord",
        name: "SettlementRecord",
        meta: { title: "结算记录", pathWay: "7-3" },
        component: resolve => {
          require(["@/views/InvitingFriends/SettlementRecord.vue"], resolve);
        }
      }
    ]
  },
  {
    path: "/",
    component: main,
    meta: {
      title: "首充活动",
      icon: "el-icon-star-off",
      pathWay: "8"
    },
    children: [
      {
        path: "/activity",
        name: "activity",
        meta: { title: "首充活动", pathWay: "8-1" },
        component: resolve => {
          require(["@/views/activity/activity.vue"], resolve);
        }
      }
    ]
  }
];

export default [
  ...routers,
  ...other,
  login, //登录页myMsg
  page500,
  page403,
  page404
];



// WEBPACK FOOTER //
// ./src/router/router.js